<template>
  <div class="wrapper">
    <div class="animated fadeIn ">
      <b-row>
        <b-col md="12">
         <b-card>
          <div slot="header">
            <strong>{{id}} List</strong>         
          </div>
          <b-row>
            <b-col md="4">
              <b-form-group label-cols-sm="3" label="Search" class="mb-0">
                <b-input-group>
                  <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col sm="12" class="text-right">
              <p > <b>Total Records :<span style="color:red;">{{totalRows}}</span></b> </p>
            </b-col>
            <b-col sm="12">
                <b-table show-empty stacked="md"  :items="items"  :fields="fields"  :current-page="currentPage"  :per-page="perPage"  :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"    @filtered="onFiltered" :bordered="bordered"    :outlined="outlined" :busy="isBusy" >
                   <div slot="table-busy" class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                      </div>     
                  </b-table> 
            </b-col>
          </b-row>
         </b-card>
       </b-col>
      </b-row>
  </div>
</div>
</template>
<script>

export default {
  data: function () {
    return {
      name: 'Hub Details List',
      id:'',
      totalRows:1, 
      items:[
        {mps_no:'mps687979',invoiceno:'test54757',sourceaddress:'pune',destinationaddress:'kolkata',deliverystatus:'Booking Done',shipmentstatus:'BookingDone',createddate:'19-12-2022',lastmodifieddate:'19-12-2022'},
        ],
      isBusy: false,
      fields: [

        { key: 'mps_no', label: 'Mps No', sortable: true, sortDirection: 'desc' },
        { key: 'invoiceno', label: 'Load ID', sortable: true, sortDirection: 'desc' },
          { key: 'sourceaddress', label: 'Source Address', sortable: true},
          { key: 'destinationaddress', label: 'Destination Address', sortable: true},
          { key: 'deliverystatus', label: 'Delivery Status', sortable: true}, 
           { key: 'shipmentstatus', label: 'Shipment Status', sortable: true},  
          { key: 'createddate', label: 'Created Date', sortable: true },
          { key: 'lastmodifieddate', label: 'Updated Date', sortable: true },
         
          // { key: 'actions', label: 'Actions' },
      ], 
      bordered: true,
      currentPage: 1,
      perPage:  10,
      pageOptions:[5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
    }
  },
  
  created: function () {
    this.id = this.$route.params.id;
  },
  methods: {
     onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
  }
}
</script>


</style>